<template>
    <span>
      <a :href="userProfileUrl" target="_blank" class="solution-link">{{userDetail.fullName}}</a>
    </span>
</template>

<script>
    import CONSTANTS from "@/store/constants";
    export default {
        name: "UserFullName",
        props:['userDetail'],

        computed: {
            userProfileUrl(){
              return CONSTANTS.EH_URL + "/profile/"+this.userDetail.userId;
            },
        }
    }
</script>

<style scoped>

</style>